import { render, staticRenderFns } from "./NuevoReciboCombustible.vue?vue&type=template&id=4f6a8d21"
import script from "./NuevoReciboCombustible.vue?vue&type=script&lang=js"
export * from "./NuevoReciboCombustible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports